<template>
  <j-overlay 
    v-model="opened" 
    class="sysenv_todo_list"
    content-right
    style="z-index: 6;"
    :id="localId"
  >
    <div class="j_todo_list__content_wrapper" :class="classWrapper">
      <div class="todolist_lnb">
      </div>
      <div class="todolist_content">        
        
        <a v-ripple class="btn-save">       
          <j-button class="type01 blue" :class="{ 'disabled': !isValid }" title="Save All" @click="onSaveTodoList">Save</j-button>
        </a>
        <a v-ripple class="btn-reqdelete" >      
          <j-button class="type01 pink" :class="{ 'disabled': getKeyValue==null }" @click="onDeleteTodoList">Delete</j-button>
        </a>
        <a v-ripple class="btn-cancel">
          <j-button class="type01 gray" @click="onClose">Close</j-button> 
        </a>

        <div>
          <!-- header -->
          <div class="todolist_tab-header">
            <span class="todolist_tab-title">WorkOrder Properties</span>
          </div>
        </div>

        <v-container class="j_form__container" fluid>

          <!-- 상단: 좌측 폼(9) + 우측 파일(3) -->
          
          <v-row class="layout wrap" align="start">
            <!-- 좌측 9 -->
            <v-col cols="12" sm="9">
              <!-- Request Originator -->
              <v-row class="layout wrap">
                <v-col cols="12" md="3" class="v-col wrap__select">
                  <v-select 
                    v-model="reqBy"
                    required
                    :class="`field ${errorClass('reqBy')}`"
                    label="Requestor"
                    item-title="text"
                    item-value="value"
                    placeholder="Select a Requestor"
                    persistent-placeholder
                    :menu-props="{ 
                      contentClass: 'single_select',
                      location: 'top',         // 메뉴가 Select 위쪽에 위치
                      origin: 'top',        // transition 기준점(애니메이션)
                      teleported: true,
                    }"
                    :list-props="{ density: 'default'}"
                    :rules="defaultRules"
                    :items="reqOptionName"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3" class="v-col wrap__select">
                  <v-text-field
                    v-if="canEditWorkfactor"
                    v-model.number="item.workfactor"
                    class="boxed_input"
                    label="W.F"
                    type="number"
                    persistent-placeholder
                  ></v-text-field>
                  <v-text-field
                    v-else
                    class="boxed_input"
                    label="W.F"
                    model-value="*"
                    readonly
                    persistent-placeholder
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="3" class="v-col">
                  <v-col class="v-col">
                    <span class="label_date">Request Date</span>
                    <j-date-picker
                      v-model="reqDate"
                      no-default
                      :clearable="false"
                      :read-only="true"
                      :nudge-left="140"
                    />
                  </v-col>
                </v-col>
                <v-col cols="12" md="3" class="d-flex padding_zero">
                  <j-button class="type01 gray" :class="{ 'off': !isReqOn }" :aria-pressed="isReqOn" @click="onToggleRequested()">{{ getTodoStatusName(reqStatus) }}</j-button>
                </v-col>
              </v-row>

              <v-row class="layout wrap" >
                <v-col cols="12" md="3" class="v-col wrap__select">
                  <v-select
                    v-model="item.phase"
                    required
                    :class="`field ${errorClass('phase')}`"
                    label="Phase"
                    item-title="phaseName"
                    item-value="phaseCode"
                    placeholder="Select a Phase"
                    persistent-placeholder
                    :menu-props="{ 
                      contentClass: 'single_select',
                      location: 'top',         // 메뉴가 Select 위쪽에 위치
                      origin: 'top',        // transition 기준점(애니메이션)
                      teleported: true,
                    }"
                    :list-props="{ density: 'compact'}"
                    :rules="codeRules"
                    :items="phaseOptionsMerged"
                    @update:model-value="onPhaseChanged"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3" class="v-col wrap__select">
                  <v-select
                    v-model="item.group"
                    required
                    label="Service Group"
                    :class="`field ${errorClass('group')}`"
                    item-title="groupName"
                    item-value="groupCode"
                    placeholder="Select a Service Group"
                    persistent-placeholder
                    :menu-props="{ 
                      contentClass: 'single_select',
                      location: 'top',         // 메뉴가 Select 위쪽에 위치
                      origin: 'top',        // transition 기준점(애니메이션)
                      teleported: true
                    }"
                    :list-props="{ density: 'compact'}"
                    :rules="codeRules"
                    :items="groupOptionsByPhase"
                    @update:model-value="onGroupChanged"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="6" class="v-col wrap__select">
                  <v-select
                    v-model="item.item"
                    required
                    :class="`Item Title ${errorClass('item')}`"
                    item-title="itemName"
                    item-value="itemCode"
                    label="Service Item"
                    placeholder="Select a Service Item"
                    persistent-placeholder
                    :menu-props="{
                      contentClass:'single_select', 
                      location: 'top',         // 메뉴가 Select 위쪽에 위치
                      origin: 'top',        // transition 기준점(애니메이션)
                      teleported: true,
                    }"
                    :list-props="{ density:'compact' }"
                    :rules="codeRules"
                    :items="itemOptionsByPhase"
                  ></v-select>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-text-field 
                    v-model="item.reqTitle" 
                    required
                    :class="`${errorClass('reqTitle')}`"
                    label="Title"
                    variant="underlined" 
                    placeholder="Input/Edit Title"
                    persistent-placeholder
                    :rules="defaultRules"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="3" class="v-col wrap__select">
                  <v-select 
                    v-model="issBy"
                    class="field"
                    label="Manager"
                    item-title="text"
                    item-value="value"
                    placeholder="Select a Manager"
                    persistent-placeholder
                    :menu-props="{ 
                      contentClass: 'single_select',
                      location: 'top',         // 메뉴가 Select 위쪽에 위치
                      origin: 'top',        // transition 기준점(애니메이션)
                      teleported: true,
                    }"
                    :list-props="{ density: 'compact'}"
                    :items="reqOptionName"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3" class="v-col wrap__select">
                  <v-select 
                    v-model="comBy"
                    class="field"
                    label="Person In Charge"
                    item-title="text"
                    item-value="value"
                    placeholder="Select a Person In Charge"
                    persistent-placeholder
                    :menu-props="{ 
                      contentClass: 'single_select',
                      location: 'top',         // 메뉴가 Select 위쪽에 위치
                      origin: 'top',        // transition 기준점(애니메이션)
                      teleported: true,
                    }"
                    :list-props="{ density: 'compact'}"
                    :items="reqOptionName"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="2" class="v-col wrap__select v-col-revision">
                  <v-text-field 
                    v-model="item.revNo"
                    class="boxed_input"
                    :class="`${errorClass('revNo')}`"
                    label="Revision No."
                    persistent-placeholder
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" class="v-col v-col-planst_date">
                  <v-col class="v-col">
                    <span class="label_date">Plan Start Date</span>
                    <j-date-picker
                      v-model="item.planstDate"
                      no-default
                      :clearable="true"
                      :read-only="false"
                      :nudge-left="140"
                    />
                  </v-col>
                </v-col><v-col cols="12" md="2" class="v-col v-col-target_date">
                  <v-col class="v-col">
                    <span class="label_date">Target Date</span>
                    <j-date-picker
                      v-model="item.targetDate"
                      no-default
                      :clearable="true"
                      :read-only="false"
                      :nudge-left="140"
                    />
                  </v-col>
                </v-col>
                <!-- <v-col cols="12" md="1" class="v-col">
                </v-col> -->
              </v-row>              
            </v-col>

            <!-- 우측 3 -->
            <v-col cols="12" md="3">
              <span class="item_title attachment">Reference Files
                <a v-ripple class="btn-attachment" title="Attach file(s)" @click="onOpenFile">
                    <i class="mdi mdi-paperclip rotate-45"></i>
                </a>
              </span>
              <div class="item_info align-top">
                <div class="item_value hx4 attachment_wrapper" style="width: 100%;">
                  <div v-for="file in files" class="attachment" :key="file.idx">
                    <span v-if="file.located=='local'" class="file_name unlink" :title="`${file.name} (${calFileSize(file.size)})`">{{ file.name }}</span>
                    <a v-else class="file_name" :title="`${file.name} (${file.size} KB)`" @click="onDownload(file.idx)">{{ file.name }}</a>
                    <!-- <span :class="`date ${file.located}`">{{ file.date }}</span> -->
                    <span class="remove">
                      <a v-ripple class="btn-delete" title="delete" @click="onDeleteFile(file)">
                        <i class="mdi mdi-trash-can-outline"></i>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="12">
              <div class="progress">
                <div class="colors">
                  <!-- <div v-if="plnProgress || hldProgress"> -->
                    <div v-if="isPlnOn" class="bar gray"   :style="`width: 100%; `">Planned</div>
                    <div v-if="isHldOn" class="bar pink2"  :style="`width: 100%; color: #ffffff; `">Hold</div>
                  <!-- </div> -->
                  <!-- <div v-else>                   -->
                    <div v-if="isReqOn" class="bar gray"   :style="`width: 10%; `">Requested</div>
                    <div v-if="isIssOn" class="bar gray2"  :style="`width: 10%; `">Issued</div>
                    <div v-if="isProOn" class="bar yellow" :style="proWidthStyle">Progress</div>
                    <div v-if="isComOn" class="bar pink"   :style="`width: 10%; `">Completed</div>
                    <div v-if="isVerOn" class="bar blue"   :style="`width: 10%; `">Verified(Dev)</div>
                    <div v-if="isLunOn" class="bar green"  :style="`width: 10%; `">Launched</div>
                  <!-- </div> -->
                </div>
                
              </div>
            </v-col>
            <v-col cols="12" md="2"  class="padding_1">
              <div class="job_status">
                <div class="title">Pending / Hold</div>
                <div class="person">
                  <span class="icon">
                    <i class="mdi mdi-account-tie"></i>
                  </span>
                  <input v-model="manager" type="text" class="name" disabled/>
                </div>
                <div class="status_wrapper">
                  <j-button class="type01 pink2" :class="{ 'off': !isHldOn }" :aria-pressed="isHldOn" @click="onToggleHold()">{{ getTodoStatusName(hldStatus) }}</j-button>
                </div>
                <VSpacer style="display: block; min-height: 4rem;"></VSpacer>
              </div>
            </v-col>
            <v-col cols="12" md="2" class="padding_2">
              <div class="job_status">
                <div class="title">Issued</div>
                <div class="person">
                  <span class="icon">
                    <i class="mdi mdi-account-tie"></i>
                  </span>
                  <input v-model="manager" type="text" class="name" disabled/>
                </div>
                <div class="status_wrapper">
                  <j-button class="type01 gray2" :class="{ 'off': !isIssOn }" :aria-pressed="isIssOn" @click="onToggleIssued()">{{ getTodoStatusName(issStatus) }}</j-button>
                </div>
                <div class="date_wrapper">
                  <span class="label_date">Date</span>
                  <j-date-picker
                    v-if="isIssOn"
                    v-model="issDate"
                    no-default
                    :clearable="true"
                  />
                  <input
                    v-else
                    :value="issDate || ''"
                    type="text"
                    class="date_display"
                    readonly
                    disabled
                  />
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" class="padding_3">
              <div class="job_status">
                <div class="title">Progress</div>
                <div class="person">
                  <span class="icon">
                    <i class="mdi mdi-account-tie"></i>
                  </span>
                  <input v-model="personInCharge" type="text" class="name" disabled/>
                </div>
                <div class="status_wrapper">
                  <j-button class="type01 yellow" :class="{ 'off': !isProOn }" :aria-pressed="isProOn" @click="onToggleProgress()">{{ getTodoStatusName(proStatus) }}</j-button>
                </div>
                <div class="progress_wrapper">
                  <div class="text_box">
                    <span class="text_label">Progress(%)</span>
                    <!-- <input v-model="disabled" name="progress" type="number" min="0" max="100"/> -->
                    <input v-model="proProg"
                      name="progress"
                      type="number"
                      :disabled="!isProOn"
                    />
                  </div>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" class="padding_4">
              <div class="job_status">
                <div class="title">Completed</div>
                <div class="person">
                  <span class="icon">
                    <i class="mdi mdi-account-tie"></i>
                  </span>
                  <input v-model="personInCharge" type="text" class="name" disabled/>
                </div>
                <div class="status_wrapper">
                  <j-button class="type01 pink" :class="{ 'off': !isComOn }" :aria-pressed="isComOn" @click="onToggleCompleted()">{{ getTodoStatusName(comStatus) }}</j-button>
                </div>
                <div class="date_wrapper">
                  <span class="label_date">Date</span>
                  <j-date-picker
                    v-if="isComOn"
                    v-model="comDate"
                    no-default
                    :clearable="true"
                  />
                  <input
                    v-else
                    :value="comDate || ''"
                    type="text"
                    class="date_display"
                    readonly
                    disabled
                  />
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" class="padding_5">
              <div class="job_status">
                <div class="title">Verified & Dev</div>
                <div class="person">
                  <span class="icon">
                    <i class="mdi mdi-account-tie"></i>
                  </span>
                  <input v-model="manager" type="text" class="name" disabled/>
                </div>
                <div class="status_wrapper">
                  <j-button class="type01 blue" :class="{ 'off': !isVerOn }" :aria-pressed="isVerOn" @click="onToggleVerified()">{{ getTodoStatusName(verStatus) }}</j-button>
                </div>
                <div class="date_wrapper">
                  <span class="label_date">Date</span>
                  <j-date-picker
                    v-if="isVerOn"
                    v-model="verDate"
                    no-default
                    :clearable="true"
                  />
                  <input
                    v-else
                    :value="verDate || ''"
                    type="text"
                    class="date_display"
                    readonly
                    disabled
                  />
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="2" class="padding_6">
              <div class="job_status">
                <div class="title">Launched</div>
                <div class="person">
                  <span class="icon">
                    <i class="mdi mdi-account-tie"></i>
                  </span>
                  <input v-model="manager" type="text" class="name" disabled/>
                </div>
                <div class="status_wrapper">
                  <j-button class="type01 green" :class="{ 'off': !isLunOn }" :aria-pressed="isLunOn" @click="onToggleLaunched()">{{ getTodoStatusName(lunStatus) }}</j-button>
                </div>
                <div class="date_wrapper">
                  <span class="label_date">Date</span>
                  <j-date-picker
                    v-if="isLunOn"
                    v-model="lunDate"
                    no-default
                    :clearable="true"
                  />
                  <input
                    v-else
                    :value="lunDate || ''"
                    type="text"
                    class="date_display"
                    readonly
                    disabled
                  />
                </div>
              </div>
            </v-col>
          </v-row>


          <v-col cols="12" class="padding_zero">
            <div class="j_todolist_comments__content_wrapper">
              <div class="comment_lnb">
              </div>
              <div class="comment_content">
                <div class="action_button_wrapper">
                  <a v-if="addable" v-ripple class="btn-add" title="add new comment" @click="onWriteComments(0)">
                    <i class="mdi mdi-plus-circle-outline"></i>
                  </a>
                  <a v-if="excelExportable" v-ripple class="btn-export" title="export to excel" @click="excelDownload">
                    <img :src="require('@/assets/img/icon/microsoft-excel.png')" width="20" height="20" />
                  </a>
                </div>
                <div>
                  <div class="comment_tab-header">
                    <span class="comment_tab-title">Menu Revision Notice</span>
                    <span class="comment_tab-sub-title">{{comments_title}}</span>
                  </div>
                  <div class="comment_wrapper">

                    <div v-for="comment in comments" :class="`comment_item depth_${comment.depth}`" :key="comment.idx">
                      <div class="avatar-wrapper">
                        <v-avatar>
                          <img :src="avatarSrc(comment.userId)" alt="avatar" />
                        </v-avatar>
                      </div>
                      <div class="member-info">
                        
                        <div class="member-name">
                          <span class="name">{{ comment.userName }}</span>
                          <span v-if="!comment.editor" class="updated">
                            <span class="date">{{ comment.date }}</span>
                            <i class="mdi mdi-clock-outline"></i>
                            <span class="time">{{ comment.time }}</span>
                          </span>
                        </div>
                        <div class="member-position">
                          <span class="position">{{ comment.office }}</span> /
                          <span class="position">{{ comment.position }}</span> /
                          <span class="department">{{ comment.dept }}</span>
                        </div>

                        <div v-if="comment.editor">
                          <j-editor 
                            style="margin-top: 2.5rem;"
                            :class="`editor depth_${comment.depth}`" 
                            :comment="comment"
                            :progress="progress" 
                            :allowNoComment="true"
                            @save="d => onSaveComments(d, comment)"
                            @cancel="onCancelComments" 
                          />
                        </div>

                        <div v-else>
                          <div class="button_replay_wrapper">
                            <!-- <a v-ripple v-if="comment.userId==account.id" class="btn-edit" title="edit" @click="onEdit(comment.idx)"> -->
                            <a v-ripple v-if="editable(comment)" class="btn-edit" title="edit" @click="onEditComments(comment.idx)">
                              <i class="mdi mdi-pencil"></i>
                            </a>
                            <a v-if="removable(comment)" v-ripple class="btn-remove" title="delete" @click="onDeleteComments(comment)">
                              <i class="mdi mdi-trash-can"></i>
                            </a>
                            <a v-if="comment.depth < max_Depth" v-ripple class="btn-reply" title="reply" @click="onWriteComments(comment.idx)">
                              <i class="mdi mdi-reply"></i>
                            </a>
                          </div>
                          <div v-html="comment.comment" class="comment"></div>                          
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-container>
      </div>

    </div>

    <input 
      type="file" 
      multiple
      id="er_files" 
      name="er_files"
      style="display:none;"
      @change="onHandleFiles"
    >
    <j-alert
      v-model="msgOpen"
      :type="msgInfo.type"
      :title="msgInfo.title"
      :titleDescription="msgInfo.titleDescription"
      :message="msgInfo.message"
      :button="msgInfo.button"
      :buttonText="msgInfo.buttonText"
      @yes="yes()"
      @cancel="msgOpen = false"
    ></j-alert>
    
  </j-overlay>
  
</template>
<script>
import '@/assets/stylus/ui/component/_sysenv.todolist.modal.scss'
import { getAvatarById } from '@/plugins/avatars'
import { mapState, mapActions } from 'vuex'
import * as d3 from 'd3'
import __M from 'moment'
import __C from '@/primitives/_constant_'
import _DefaultData from '@/primitives/_todoListDefault'
import { CommunicationService, FileService, SystemService, AdminService, DBSupportService } from "@/services"
import { SafeIdMixin } from '@/mixins/safeid.mixin'
import Url from '@/services/api/request.url'
import StaticOptions from '@/mixins/staticOptions'

export default {
  name: 'j-modal-slide-component--service-todolist',
  mixins: [
    SafeIdMixin,
    StaticOptions
  ],
  props: {
    keyValue: null,
    modelValue:{ type: Boolean, default: false },
  },
  data: () => ({
    communicationService: null,
    fileService: null,
    systemService: null,
    adminService: null,

    comments: [],
    files2: [],
    item: {},

    prevItem: {},
    date: null,
    newKeyValue: null,

    phaseOptions: [],
    groupOptions: [],
    itemOptions: [],
    subItemOptions: [],
    todoOptions: [],
    _revToken: null,
    _suspendNavChanged: false,

    classWrapper: 'closed',
    opened: false,
    error: '',
    localFiles: [],
    required: ['reqBy','reqTitle', 'phase', 'group', 'item'],
    errors: [],
    progress: {
      complete: 0,
      total: 0
    },

    msgOpen: false,
    msgInfo: {
      type: "",
      title: "",
      titleDescription: "",
      message: "",
      button: [true, false, true],
      buttonText: ["Yes", "No", "Cancel"]
    },
    yes: () => {},
    max_Depth: 5,
    commentPropsLocal: {
      refCode: '',               // `TodoList_${this.keyValue}`
      sender: null,              // 'ITEM_BLOCK'
      extFields: [],             
      excel: { exportable: false, tableIdx: null },
      title: '',                 
    },
    updatecommentLocal: false,   // store.updatecomment
    callbackDataLocal: null,     // store.callbackData
    stageOrder: ['requested','issued','progress','completed','verified','launched'],
    defaultRules: [(v) => !!v || 'Required'],
    codeRules: [(v) => (!!v && v != 'NONE' && v.length > 0) || 'Required'],
    todoReqOptionName: [],     // Exchange Member name for Display
    memberNameMap: {},         // { 'seungwook.han': 'SeungWook', ... }
    members: [],
  }),
  computed: {
    ...mapState(__C.STORE_NAMESPACE.ACCOUNT, ['account']),

    __C_() { return __C },
    today() { return __M().format('YYYY-MM-DD') },
    canEditWorkfactor() {
      const accountId = String(this.account?.id || '').split('@')[0].toLowerCase()
      console.log(accountId)
      return ['jinkee', 'seungwook.han'].includes(accountId)
    },

    modeNew() { return this.formMode == __C.FORM.EDIT_MODE_NEW },
    modeMod() { return this.formMode == __C.FORM.EDIT_MODE_MOD },
    formMode() {
      // After first save, prefer newly assigned key (newKeyValue) as the source of truth
      if (this.getKeyValue) return __C.FORM.EDIT_MODE_MOD
      else return __C.FORM.EDIT_MODE_NEW
    }, 
    getKeyValue() {
      return this.newKeyValue || this.keyValue || null
    },
    files() { 
      let files_ = [];
      (this.item.files || []).forEach(f => {
        files_.push({ located: 'remote', ...f })
      })
      this.localFiles.forEach(f => {
        files_.push({ 
          located: 'local',
          date: this.today,
          name: f.name,
          size: Math.round(f.size / 1024)
        })
      })
      return files_.sort((a, b) => (a.date < b.date) ? 1 : ((a.date === b.date) ? ((a.name > b.name) ? 1 : -1) : -1) )
    },
    comments_title() { 
      if (this.commentPropsLocal.title) return this.commentPropsLocal.title
      return 'Comments List'
    },
    addable(){
      if(!this.getKeyValue) return false
      return true
    },
    senderItemBlock () { return this.commentPropsLocal.sender || this.commentPropsLocal.sender == 'ITEM_BLOCK' },
    sender2input() { 
      if(!this.commentPropsLocal.sender || !(['ITEM_BLOCK']).includes(this.commentPropsLocal.sender)) return []
      return this.commentPropsLocal.extFields ? JSON.parse(JSON.stringify(this.commentPropsLocal.extFields)) : []
    },
    excelExportable() { return !!(this.commentPropsLocal.excel && this.commentPropsLocal.excel.exportable) },
    tableIdx() { return this.commentPropsLocal.excel ? this.commentPropsLocal.excel.tableIdx : null  },
    isValid() { return this.validateForm() },
    plnStatus: {
      get() { return this.item.plnProc ? this.item.plnProc.plnStatus : '' },
      set(val) { this.setPlnProc(); this.item.plnProc.plnStatus = val }
    },
    plnDate: {
      get() { return this.item.plnProc ? this.item.plnProc.plnDate : '' },
      set(val) { this.setPlnProc(); this.item.plnProc.plnDate = val }
    },
    plnBy: {
      get() { return this.item.plnProc ? this.item.plnProc.plnBy : '' },
      set(val) { this.setPlnProc(); this.item.plnProc.plnBy = val }
    },
    plnProg: {
      get() { return this.item.plnProc ? this.item.plnProc.plnProg : 100 },
      set(val) { this.setPlnProc(); this.item.plnProc.plnProg = val }
    },
    hldStatus: {
      get() { return this.item.hldProc ? this.item.hldProc.hldStatus : '' },
      set(val) { this.setHldProc(); this.item.hldProc.hldStatus = val }
    },
    hldDate: {
      get() { return this.item.hldProc ? this.item.hldProc.hldDate : '' },
      set(val) { this.setHldProc(); this.item.hldProc.hldDate = val }
    },
    hldBy: {
      get() { return this.item.hldProc ? this.item.hldProc.hldBy : '' },
      set(val) { this.setHldProc(); this.item.hldProc.hldBy = val }
    },
    hldProg: {
      get() { return this.item.hldProc ? this.item.hldProc.hldProg : '' },
      set(val) { this.setHldProc(); this.item.hldProc.hldProg = val }
    },
    reqStatus: {
      get() { return this.item.reqProc ? this.item.reqProc.reqStatus : '' },
      set(val) { this.setReqProc(); this.item.reqProc.reqStatus = val }
    },
    reqDate: {
      get() { return this.item.reqProc ? this.item.reqProc.reqDate : '' },
      set(val) { this.setReqProc(); this.item.reqProc.reqDate = val }
    },
    reqBy: {
      get() { return this.item.reqProc ? this.item.reqProc.reqBy : '' },
      set(val) { this.setReqProc(); this.item.reqProc.reqBy = val }
    },
    reqProg: {
      get() { return this.item.reqProc ? this.item.reqProc.reqProg : '' },
      set(val) { this.setReqProc(); this.item.reqProc.reqProg = val }
    },
    issStatus: {
      get() { return this.item.issProc ? this.item.issProc.issStatus : '' },
      set(val) { this.setIssProc(); this.item.issProc.issStatus = val }
    },
    issDate: {
      get() { return this.item.issProc ? this.item.issProc.issDate : '' },
      set(val) { this.setIssProc(); this.item.issProc.issDate = val }
    },
    issBy: {
      get() { return this.item.issProc ? this.item.issProc.issBy : '' },
      set(val) { this.setIssProc(); this.item.issProc.issBy = val }
    },
    issProg: {
      get() { return this.item.issProc ? this.item.issProc.issProg : '' },
      set(val) { this.setIssProc(); this.item.issProc.issProg = val }
    },
    verStatus: {
      get() { return this.item.verProc ? this.item.verProc.verStatus : '' },
      set(val) { this.setVerProc(); this.item.verProc.verStatus = val }
    },
    verDate: {
      get() { return this.item.verProc ? this.item.verProc.verDate : '' },
      set(val) { this.setVerProc(); this.item.verProc.verDate = val }
    },
    verBy: {
      get() { return this.item.verProc ? this.item.verProc.verBy : '' },
      set(val) { this.setVerProc(); this.item.verProc.verBy = val }
    },
    verProg: {
      get() { return this.item.verProc ? this.item.verProc.verProg : '' },
      set(val) { this.setVerProc(); this.item.verProc.verProg = val }
    },
    proStatus: {
      get() { return this.item.proProc ? this.item.proProc.proStatus : '' },
      set(val) { this.setProProc(); this.item.proProc.proStatus = val }
    },
    proDate: {
      get() { return this.item.proProc ? this.item.proProc.proDate : '' },
      set(val) { this.setProProc(); this.item.proProc.proDate = val }
    },
    proBy: {
      get() { return this.item.proProc ? this.item.proProc.proBy : '' },
      set(val) { this.setProProc(); this.item.proProc.proBy = val }
    },
    proProg: {
      get() { return this.item.proProc ? this.item.proProc.proProg : '' },
      set(val) { this.setProProc(); this.item.proProc.proProg = val }
    },
    comStatus: {
      get() { return this.item.comProc ? this.item.comProc.comStatus : '' },
      set(val) { this.setComProc(); this.item.comProc.comStatus = val }
    },
    comDate: {
      get() { return this.item.comProc ? this.item.comProc.comDate : '' },
      set(val) { this.setComProc(); this.item.comProc.comDate = val }
    },
    comBy: {
      get() { return this.item.comProc ? this.item.comProc.comBy : '' },
      set(val) { this.setComProc(); this.item.comProc.comBy = val }
    },
    comProg: {
      get() { return this.item.comProc ? this.item.comProc.comProg : '' },
      set(val) { this.setComProc(); this.item.comProc.comProg = val }
    },
    lunStatus: {
      get() { return this.item.lunProc ? this.item.lunProc.lunStatus : '' },
      set(val) { this.setLunProc(); this.item.lunProc.lunStatus = val }
    },
    lunDate: {
      get() { return this.item.lunProc ? this.item.lunProc.lunDate : '' },
      set(val) { this.setLunProc(); this.item.lunProc.lunDate = val }
    },
    lunBy: {
      get() { return this.item.lunProc ? this.item.lunProc.lunBy : '' },
      set(val) { this.setLunProc(); this.item.lunProc.lunBy = val }
    },
    lunProg: {
      get() { return this.item.lunProc ? this.item.lunProc.lunProg : '' },
      set(val) { this.setLunProc(); this.item.lunProc.lunProg = val }
    },
    isPlnOn() { return this.plnProg > 0 ? true : false },
    isHldOn() { return this.hldProg > 0 ? true : false },
    isReqOn() { return this.reqProg > 0 ? this.hldProg > 0 ? false : true : false },
    isIssOn() { return this.issProg > 0 ? this.hldProg > 0 ? false : true : false },
    isVerOn() { return this.verProg > 0 ? this.hldProg > 0 ? false : true : false },
    isProOn() { return this.proProg > 0 ? this.hldProg > 0 ? false : true : false },
    isComOn() { return this.comProg > 0 ? this.hldProg > 0 ? false : true : false },
    isLunOn() { return this.lunProg > 0 ? this.hldProg > 0 ? false : true : false },
    reqOptionName() { return this.todoReqOptionName.length ? this.todoReqOptionName : this.QueryReqOption },
    manager () { return this.getManagerName(this.issBy) || '' },
    personInCharge () { return this.getManagerName(this.comBy) || '' },
    proWidthPercent() { 
      const p = Number(this.proProg) || 0
      return (p * 0.5).toFixed(2) + '%' 
    },
    proWidthStyle() { return `width: ${this.proWidthPercent};` },
    
    QueryOptionsByKey() {
      const map = {}
      for (const r of (this.todoOptions || [])) {
        const k = r.key || ''
        ;(map[k] ||= []).push(r)
      }
      return map
    },
    QueryTypeOption() {
      const optvalue = this.QueryOptionsByKey['todoTypeOption'] || []
      return optvalue
    },
    QueryStatusOption() {
      const optvalue = this.QueryOptionsByKey['todoStatusOption'] || []
      return optvalue
    },
    QueryStatusFilter() {
      const optvalue = this.QueryOptionsByKey['todoStatusFilter'] || []
      return optvalue
    },
    QueryReqOption() {
      const optvalue = this.QueryOptionsByKey['todoReqOption'] || []
      return optvalue
    },
    QueryNavOption() {
      const optvalue = this.QueryOptionsByKey['todoNavOption'] || []
      return optvalue
    },
    isNavCode() {
      return (code) => String(code || '').startsWith('NAV-')
    },
    isNavPhase() {
      return this.isNavCode(this.item?.phase)
    },
    groupOptionsByPhase() {
      return this.isNavPhase ? (this.navGroupOptions || []) : (this.groupOptions || [])
    },
    itemOptionsByPhase() {
      return this.isNavPhase ? (this.navItemOptions || []) : (this.itemOptions || [])
    },
    phaseOptionsMerged() {
      return this.dupDelete([...(this.phaseOptions || []), ...this.navPhaseOptions], 'phaseCode')
    },
    groupOptionsMerged() {
      return this.dupDelete([...(this.groupOptions || []), ...this.navGroupOptions], 'groupCode')
    },
    itemOptionsMerged() {
      return this.dupDelete([...(this.itemOptions || []), ...this.navItemOptions], 'itemCode')
    },
    navPhaseOptions() {
      return (this.QueryNavOption || []).map(o => ({
        phaseCode: o.value,
        phaseName: o.text,
        _nav: true,
      }))
    },
    navGroupOptions() {
      return (this.QueryNavOption || []).map(o => ({
        groupCode: o.value,
        groupName: o.text,
        _nav: true,
      }))
    },
    navItemOptions() {
      return (this.QueryNavOption || []).map(o => ({
        itemCode: o.value,
        itemName: o.text,
        _nav: true,
      }))
    },
    dupDelete() {
      return (arr, key) => {
        const seen = new Set()
        return (arr || []).filter(x => {
          const k = x?.[key]
          if (!k) return true
          if (seen.has(k)) return false
          seen.add(k)
          return true
        })
      }
    },
  },
  watch: {
    'item.phase': 'onNavChanged',
    'item.group': 'onNavChanged',
    'item.item' : 'onNavChanged',
    modelValue(val) {
      this.localFiles = []
      if(val) {
        if(this.modeNew) {
          this.item = JSON.parse(JSON.stringify(_DefaultData))
          this.loadMemberNames()
          this.initReqByIfEmpty()
          this.reqBy = this.getAccountId()
          this.setPlan('planned') // ← 이제 다른 단계 0% 초기화 + planned=100 확정
          // this.reqDate = this.today
          
        } else {
          this.getTodoList(this.keyValue)
          this.mode = __C.FORM.EDIT_MODE_VIEW
        }
        this.updateCommentRef()

        this.onOpen()
        this.getComments()
      } else {
        this.onClose()
        this.newKeyValue = null

      }
    },
    keyValue() {
      this.updateCommentRef()
    },
    newKeyValue() {
      this.updateCommentRef()
    }
  },
  created() {
    this.localId = this.id || 'j-todo-list__' + this.safeId('')
    this.systemService = new SystemService()
    this.communicationService = new CommunicationService()
    this.fileService = new FileService()
    this.adminService = new AdminService()
    this.queryLibService = new DBSupportService()
  },
  mounted() {
    this.systemService.getNavPhase(res => {
      if (!res) this.phaseOptions = []
      else this.phaseOptions = [
        { phaseCode: 'NA', phaseName: 'None' },
        ...res
      ]
    })    
    if(this.keyValue) {
      this.setCommentProps({ refCode: `TodoList_${this.keyValue}` })
      this.getComments()
    } 

    this.loadTodoOptions()
    this.loadMemberNames()
    this.initReqByIfEmpty()
  },
  methods: {
    ...mapActions(__C.STORE_NAMESPACE.INTENDED_DATAGRID, [
      'GET_EXCEL',
    ]),
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Request
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    onOpen() {
      this.opened = true
      setTimeout(() => { 
        this.classWrapper = 'opened' 
        d3.select(`#${this.localId}`).select('.todolist_content').transition().delay(300).duration(200).style('opacity', 1)
      })
    },
    onClose() {
      this.setCommentProps({ refCode: null })
      d3.select(`#${this.localId}`).select('.todolist_content').transition().duration(150).style('opacity', 0)
      setTimeout(() => { 
        this.classWrapper = 'closed'
      }, 50)
      setTimeout(() => { 
        this.opened = false
        this.$emit('update:modelValue', false) 
      }, 150)
    },
    onPhaseChanged(phaseCode) {
      if(phaseCode == '') return
      
      this.groupOptions = []
      this.itemOptions = []

      if (this.isNavCode(phaseCode)) {
        this.item.group = phaseCode
        this.item.item = phaseCode
        return
      }

      this.systemService.getNavGroup(phaseCode, res => {
        if (res) this.groupOptions = [ { groupCode: 'NA', groupName: 'None' }, ...res ]
      })
    },
    onGroupChanged(groupCode) {
      if(groupCode == '') return
      this.itemOptions = []

      if (this.isNavCode(this.item.phase) || this.isNavCode(groupCode)) {
        this.item.item = groupCode
        return
      }

      this.systemService.getNavItem(
        res => {
          if(res) this.itemOptions = [ { itemCode: 'NA', itemName: 'None' }, ...res ]
        },
        this.item.phase,
        groupCode
      )
    },
    onItemChanged(itemCode) {
      this.subItemOptions = [
        {
          idx: 0,
          subItemName: 'None',
        }
      ]
      if (itemCode == '') return
      if (!this.item.phase || !this.item.item) return

      this.systemService.getNavSubItem(
        res => {
          if (res) this.subItemOptions = [ ...this.subItemOptions, ...res ]
        },
        this.item.phase,
        this.item.item
      )
    },
    onSaveTodoList() {
      if(!this.validateForm()) return
      if(!this.validateStageDates()) return

      let todolist_ = JSON.parse(JSON.stringify(this.item))
      let postSave = (idx_) => {
        this.localFiles = []
        this.progress = { complete: 0, total: 0 }
        this.getTodoList(idx_,'save')
        this.newKeyValue = idx_
        this.$emit('saved')
        this.onClose()
      }
      
      if(this.modeNew) this.systemService.putTodoList(todolist_).then(idx => {
        this.onSaveFile(idx).then(() => { postSave(idx) })
      }); else this.systemService.updTodoList(todolist_).then(idx => {
        this.onSaveFile().then(() => { postSave(this.getKeyValue) })
      })
    },
    onDeleteTodoList() {
      if (!this.getKeyValue) {
        // new request delete
        this.yes = () => {
          this.msgOpen = false
          this.localFiles = []          
          this.newKeyValue = null
          this.item = JSON.parse(JSON.stringify(_DefaultData))        
          this.onClose()
          this.$emit('deleted')  
          this.yes = () => {}
        }
        this.msgInfo.type = "WARN"
        this.msgInfo.title = "Action Approval"
        this.msgInfo.message = "Do you want to delete this Request?"
        this.msgInfo.button = [true, false, true]
        this.msgInfo.buttonText = ['Yes', 'No', 'Cancel']
        this.msgInfo.buttonText[0] = "Delete"
        this.msgOpen = true
        return
      }
      
      // saved request → 서버에 일괄 삭제 요청 (요청+첨부파일+코멘트)
      this.yes = () => {
        this.msgOpen = false
        const idx = this.getKeyValue
        this.isBusy = true
        this.systemService.delTodoList(idx)
          .then(() => {
            this.localFiles = []
            this.item = JSON.parse(JSON.stringify(_DefaultData))
            this.newKeyValue = null
            this.setCommentProps({ refCode: null })
            this.onClose()
            this.$emit('deleted')
            this.yes = () => {}
          })
      }
      this.msgInfo.type = "WARN"
      this.msgInfo.title = "Action Approval"
      this.msgInfo.message = "Do you want to delete this Request?"
      this.msgInfo.button = [true, false, true]
      this.msgInfo.buttonText = ['Yes', 'No', 'Cancel']
      this.msgInfo.buttonText[0] = "Delete"
      this.msgOpen = true
    },
    isBarStyleComplete(color, prog) {
      return prog == 100 ? 'gray' : color
    },
    getTodoStatusName(code) {
      let option = this.todoStatusOption.find(opt => opt.value == code)
      return option ? option.text : ''
    },
    getTodoList(_idx,mode='view') {

      this.systemService.getTodoList(_idx).then(res => {
        // Prevent revNo auto-refresh while hydrating saved record
        this._suspendNavChanged = true
        this.item = res

        if (mode == 'view') {
          this.onPhaseChanged(this.item.phase)
          this.onGroupChanged(this.item.group)
          this.onItemChanged(this.item.item)
        }

        // Re-enable revNo auto-refresh after initial binding settles
        this.$nextTick(() => { this._suspendNavChanged = false })
      })
    },
    loadTodoOptions() {
      this.queryLibService.getSqlQueryResult({ 
        idx: 0, 
        name: 'Workorder Options',
        filters: ''
      }).then(result => {
        this.todoOptions = Array.isArray(result) ? result : []
      })
    },
    async onNavChanged() {
      if (this._suspendNavChanged) return
      const phase = this.item?.phase
      const group = this.item?.group
      const item  = this.item?.item

      if (!phase || !group || !item) { this.item.revNo = ''; return }
      if (phase === 'NA' || group === 'NA' || item === 'NA') { this.item.revNo = '' ; return }
      // if (this.isNavCode(phase) || this.isNavCode(group) || this.isNavCode(item)) { this.item.revNo = '' ; return }

      const token = `${phase}|${group}|${item}|${Date.now()}`
      this._revToken = token

      try {
        const rev = await this.getRevNo()
        if (this._revToken !== token) return
        this.item.revNo = rev ?? ''
      } catch (e) {
        if (this._revToken !== token) return
        this.item.revNo = ''
      }
      
    },
    getRevNo(){
      if(!this.item.phase || !this.item.group || !this.item.item) return Promise.resolve(null)

      const phase_ = this.item.phase || ''
      const group_ = this.item.group || ''
      const item_  = this.item.item  || ''

      const cond = []
      if (phase_) cond.push(`[PHASE] = '${phase_}'`)
      if (group_) cond.push(`[GROUP] = '${group_}'`)
      if (item_)  cond.push(`[ITEM]  = '${item_}'`)
      const filter_ = cond.join(' AND ')

      return this.queryLibService.getSqlQueryResult({
        idx: 0,
        name: 'Workorder Revision',
        filters: filter_
      }).then(res => {
        return Array.isArray(res) ? res?.[0]?.NewRevNo : res        
      }).catch(() => {
        return null
      })
    },
    setTodoStatus(type, code) {
      let index_ = this.QueryStatusOption.findIndex(s => s.value == code)
      this.item[type].status = this.QueryStatusOption[index_].value

      const jobDate = `${this.item.jobLog?'\n':''}[${__M().format('YYYY-MM-DD HH:mm:ss')}] `
      const jobStatusFrom = ` '${this.QueryStatusOption[index_].text}' has changed to '`
      const jobStatusTo = `${this.getTodoStatusName(this.item[type].status)}' by ${this.account? this.getAccountId() : ''}'`

      this.item.jobLog += jobDate + jobStatusFrom + jobStatusTo
    },
    // initialize proc objects if they are null
    setPlnProc() { if (!this.item.plnProc) this.item.plnProc = {} },
    setHldProc() { if (!this.item.hldProc) this.item.hldProc = {} },
    setReqProc() { if (!this.item.reqProc) this.item.reqProc = {} },
    setIssProc() { if (!this.item.issProc) this.item.issProc = {} },
    setVerProc() { if (!this.item.verProc) this.item.verProc = {} },
    setProProc() { if (!this.item.proProc) this.item.proProc = {} },
    setComProc() { if (!this.item.comProc) this.item.comProc = {} },
    setLunProc() { if (!this.item.lunProc) this.item.lunProc = {} },
    
    errorClass(name) {
      if(this.errors.includes(name)) return ' required'
      return ''
    },
    validateForm() {
      let errors_ = []
      this.required.forEach(name => {
        if(name == 'reqBy') {
          if(!this.reqBy) errors_.push(name)
        } else {
          if(!this.item[name]) errors_.push(name) 
        }
      })
      this.errors = errors_
      return errors_.length === 0
    },
    validateStageDates() {
      const stages = [
        { enabled: this.isIssOn, label: 'Issued', date: this.issDate },
        { enabled: this.isComOn, label: 'Completed', date: this.comDate },
        { enabled: this.isVerOn, label: 'Verified & Dev', date: this.verDate },
        { enabled: this.isLunOn, label: 'Launched', date: this.lunDate },
      ]

      const missing = stages.find(stage => stage.enabled && !stage.date)
      if (!missing) return true

      this.yes = () => {
        this.msgOpen = false
        this.yes = () => {}
      }
      this.msgInfo.type = 'WARN'
      this.msgInfo.title = 'Date Required'
      this.msgInfo.titleDescription = ''
      this.msgInfo.message = `${missing.label} date is required.`
      this.msgInfo.button = [true, false, false]
      this.msgInfo.buttonText = ['OK', '', '']
      this.msgOpen = true

      return false
    },
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Files
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    onHandleFiles(e) {
      if(!e || !e.target) return
      this.appendFiles(Object.values(e.target.files).filter(f_ => !!f_))
      document.querySelector(`input[name='er_files']`).value = null
    },
    onOpenFile() {
      document.querySelector(`input[name='er_files']`).click()
    },
    appendFiles(_files) {
      _files.forEach(f => {
        if(this.localFiles.find(f__ => f__.name == f.name)) return

        f.date = this.today
        this.localFiles.push(f)
      })
    },
    calFileSize(size) {
      return (size ? Math.round(size/1024).toLocaleString() : 0) + ' KB'
    },
    onDeleteFile(file) {
      if(file.located == 'local') {
        let i = this.localFiles.findIndex(f => f.name == file.name)
        if(i < 0) return

        this.localFiles[i] = null
        this.localFiles = this.localFiles.filter(f => !!f)
        return
      }

      this.yes = () => {
        this.msgOpen = false
        this.systemService.delTodoListFile(file.idx).then(() => {
          this.systemService.getTodoListFiles(this.keyValue).then(res => {
            this.item.files = res
          })
        })
        this.yes = () => {}
      }

      this.msgInfo.type = "WARN"
      this.msgInfo.title = "Action Approval"
      this.msgInfo.message = "Do you want to delete this attachment?"
      this.msgInfo.button = [true, false, true]
      this.msgInfo.buttonText = ['Yes', 'No', 'Cancel']
      this.msgInfo.buttonText[0] = "Delete"
      this.msgOpen = true
    },
    onDeleteFiles(idx=null) {
      // 1) 로컬만 있는 경우 (신규 작성중, 아직 서버 저장 안함)
      if (!this.getKeyValue) {
        this.yes = () => {
          this.msgOpen = false
          this.localFiles = []
          this.item.files = []
          this.progress = { complete: 0, total: 0 }
          this.yes = () => {}
        }
        
        this.msgOpen = true
        this.msgInfo.type = "WARN"
        this.msgInfo.title = "Action Approval"
        this.msgInfo.message = "Do you want to delete this attachment?"
        this.msgInfo.button = [true, false, true]
        this.msgInfo.buttonText = ['Yes', 'No', 'Cancel']
        this.msgInfo.buttonText[0] = "Delete"
        this.msgOpen = true
        return
      }
      // 2) 서버에 저장된 첨부 모두 삭제
      this.yes = () => {
        this.msgOpen = false
        const idx = this.getKeyValue
        this.systemService.delTodoListFiles(idx).then(() => { 
          this.systemService.getTodoListFiles(idx).then(res => {
            this.item.files = res
            this.localFiles = []
            this.progress = { complete: 0, total: 0 }
            this.yes = () => {}
          })
        })
      }
      this.msgOpen = true
      this.msgInfo.type = "WARN"
      this.msgInfo.title = "Action Approval"
      this.msgInfo.message = "Do you want to delete all attachments?"
      this.msgInfo.button = [true, false, true]
      this.msgInfo.buttonText = ['Yes', 'No', 'Cancel']
      this.msgInfo.buttonText[0] = "Cancel"
      this.msgOpen = true
    },
    onSaveFile(idx=null) {
      if(this.localFiles.length === 0)
        return new Promise(resolve => { resolve(-1) })

      let data_ = {
        idx: idx || this.getKeyValue,
        files : this.localFiles.map(f => {
          let fileNameParts = f.name.split('.')
          return {
            name      : f.name,
            mimeType  : f.type,
            fileType  : f.type.split('/')[0],
            ext       : fileNameParts[fileNameParts.length-1],
            dataUrl   : '',
            size      : Number(f.size),
            dimention : '',
          }
        })
      }
      let config = {
        onUploadProgress: e => {
          this.progress = {
            complete: e.loaded,
            total: e.total
          }
        }
      }
      let params = new FormData()
      params.append("data", JSON.stringify(data_))
      this.localFiles.forEach(f => { params.append("files", f) })

      return this.systemService.putTodoListFiles(params, config)
    },
    onDownload(fileId) {
      var iframe = document.createElement('iframe')
      document.body.appendChild(iframe)
      let params = new URLSearchParams()
      params.append('token', this.account.token)
      iframe.src = `${Url.download}/${fileId}?${params.toString()}`

      // setTimeout(() => {
      //   iframe.parentNode.removeChild(iframe)
      // }, 10000);
    },
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Comments
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    updateCommentRef() {
      const k = this.getKeyValue
      if (!k) return
      this.setCommentProps({ refCode: `TodoList_${k}` })
      // refCode 반영 후 다음 틱에 댓글 로딩(레이스 컨디션 방지)
      this.$nextTick(() => this.getComments())
    },
    getComments() {
      const ref = (this.commentPropsLocal?.refCode || '').toUpperCase()
      if (!ref) { this.comments = []; return }
      this.communicationService.getComments(ref).then(res => {
        this.comments = res
      })
    },
    removable(comment) {
      if(!this.getKeyValue) return false
      if(comment.depth == 0 && this.comments.findIndex(c_ => c_.parentId == comment.idx) >= 0) return false
      if(this.account && this.account.permitLevel <= __C.ACCOUNT.PERMISSION_LEVEL.SVC_ADMIN) return true
      if(comment.userId != this.account.id) return false
      
      return true
    },
    editable(comment) {
      if(!this.getKeyValue) return false
      if(this.account && this.account.permitLevel <= __C.ACCOUNT.PERMISSION_LEVEL.SVC_ADMIN) return true
      if(comment.userId != this.account.id) return false
      //if(comment.depth == 0 && this.comments.findIndex(c_ => c_.parentId == comment.idx) >= 0) return false
      return false
    },

    onCancelComments(data, comment) {
      let index_ = this.comments.findIndex(c_ => c_.editor)
      if(index_ < 0) return

      let comments_ = [ ...this.comments ]
      if(this.mode == __C.FORM.EDIT_MODE_EDIT) {
        comments_[index_].editor = false
        comments_[index_].mode = __C.FORM.EDIT_MODE_VIEW

        if (data != undefined)  {
          comments_[index_].comment = data.comment
          this.comments = comments_
    
          let data_ = {
            parentId: comment.parentId,
            refCode : this.commentPropsLocal.refCode.toUpperCase(),
            userId  : this.account.id,
            comment : data.comment,
            ext1    : comment.ext1,
            ext2    : comment.ext2,
            ext3    : comment.ext3,
            ext4    : comment.ext4,
            ext5    : comment.ext5,
            files   : data.files.map(f => ({
              name      : f.name,
              mimeType  : f.mimeType,
              fileType  : f.fileType,
              ext       : f.ext,
              dataUrl   : f.dataUrl,
              size      : f.size,
              dimention : f.dimention,
            }))
          }

          let params = new FormData()
          params.append("idx", comments_[index_].idx)
          params.append("data", JSON.stringify(data_))
          
          data.files.forEach(f => { params.append("files", f) })
          
          let config = {
            onUploadProgress: e => {
              this.progress = {
                complete: e.loaded,
                total: e.total
              }
            }
          }

          this.communicationService.editComment(params, config).then(() => {
            this.progress = { complete: 0, total: 0 }
            this.getComments()
            this.mode = __C.FORM.EDIT_MODE_VIEW
            this.setUpdateComment(!this.updatecommentLocal)
            
            setTimeout(() => {
              this.setCallbackData({
                from: 'Comment Service',
                refCode: this.commentPropsLocal.refCode,
                count: this.comments.length,
                comments: JSON.parse(JSON.stringify(this.comments))
              })
              
            }, 500)
          })
        }else {
          this.getComments()
          this.mode = __C.FORM.EDIT_MODE_VIEW
        }

      } else {
        comments_[index_] = null
        this.comments = comments_.filter(c_ => !!c_)
      }

      this.mode = __C.FORM.EDIT_MODE_VIEW

    },
    onDeleteComments(comment) {
      this.yes = () => {
        this.msgOpen = false
        this.communicationService.delComment(comment.idx).then(() => {
          let index_ = this.comments.findIndex(c_ => c_.idx == comment.idx)
          let comments_ = [ ...this.comments ]
          comments_[index_] = null
          this.comments = comments_.filter(c_ => !!c_)
          
          setTimeout(() => {
            this.setCallbackData({
            from: 'Comment Service',
            refCode: this.commentPropsLocal.refCode,
            count: this.comments.length,
            comments: JSON.parse(JSON.stringify(this.comments))
          })
          }, 500)
        })

        this.setUpdateComment(!this.updatecommentLocal)

        this.yes = () => {}
      }

      this.msgInfo.type = "WARN"
      this.msgInfo.title = "Action Approval"

      if(comment.files.length > 0) {
        this.msgInfo.titleDescription = "Important Notification"
        this.msgInfo.message = `
          <span style="
            font-style: italic; 
            font-weight: 300; 
            font-size: 12px; 
            color: #f75c02
          ">
            Attention: All of its attachments will be deleted.
          </span><br /><br />
          Do you want to delete this comment?
        `
      } else this.msgInfo.message = "Do you want to delete this comment?"

      this.msgInfo.button = [true, false, true]
      this.msgInfo.buttonText = ['Yes', 'No', 'Cancel']
      this.msgInfo.buttonText[0] = "Delete"
      this.msgOpen = true
    },
    onEditComments(idx) {
      if(this.mode != __C.FORM.EDIT_MODE_VIEW) return

      let comments_ = [ ...this.comments ]
      let index_ = this.comments.findIndex(c_ => c_.idx == idx)
      comments_[index_].editor = true
      comments_[index_].mode = __C.FORM.EDIT_MODE_EDIT

      this.comments = comments_
      this.mode = __C.FORM.EDIT_MODE_EDIT

      setTimeout(() => {
        this.setCallbackData({
        from: 'Comment Service',
        refCode: this.commentPropsLocal.refCode,
        count: this.comments.length,
        comments: JSON.parse(JSON.stringify(this.comments))
      })
      }, 500)
    },
    onSaveComments(data, comment) {
      // this.loading = true
      if(this.mode == __C.FORM.EDIT_MODE_EDIT) {
        this.onCancelComments(data, comment)
        return
      }
      
      let data_ = {
        parentId: comment.parentId,
        refCode : this.commentPropsLocal.refCode.toUpperCase(),
        userId  : this.account.id,
        comment : data.comment,
        ext1    : comment.ext1,
        ext2    : comment.ext2,
        ext3    : comment.ext3,
        ext4    : comment.ext4,
        ext5    : comment.ext5,
        files   : data.files.map(f => ({
          name      : f.name,
          mimeType  : f.mimeType,
          fileType  : f.fileType,
          ext       : f.ext,
          dataUrl   : f.dataUrl,
          size      : f.size,
          dimention : f.dimention,
        }))
      }

      let params = new FormData()
      params.append("data", JSON.stringify(data_))
      
      data.files.forEach(f => { params.append("files", f) })

      let config = {
        onUploadProgress: e => {
          this.progress = {
            complete: e.loaded,
            total: e.total
          }
        }
      }
      this.communicationService.putComment(params, config).then(() => {
        this.progress = { complete: 0, total: 0 }
        this.getComments()
        this.mode = __C.FORM.EDIT_MODE_VIEW
        
        this.setUpdateComment(!this.updatecommentLocal)

        setTimeout(() => {
          this.setCallbackData({
            from: 'Comment Service',
            refCode: this.commentPropsLocal.refCode,
            count: this.comments.length,
            comments: JSON.parse(JSON.stringify(this.comments))
          })
        }, 500)
      })
    },
    onWriteComments(parentId) {
      // if (this.mode != __C.FORM.EDIT_MODE_VIEW) return

      let depth_ = 0
      let parentIdxNum = Number(parentId) || 0
      let parentIndexInArray = -1

      if (parentIdxNum) {
        parentIndexInArray = this.comments.findIndex(c_ => c_.idx == parentIdxNum)
        if (parentIndexInArray < 0) {
          console.warn('Parent comment not found:', parentId)
          return
        }
        depth_ = Number(this.comments[parentIndexInArray].depth || 0) + 1
        if (depth_ > this.max_Depth) {
          this.yes = () => {
            this.msgOpen = false
            this.yes = () => {}
            this.onCancelComments('', '')
            return
          }

          this.msgInfo.type = "WARN"
          this.msgInfo.title = "Reply"
          this.msgInfo.message = `Nested comments are limited to ${this.max_Depth} levels.`,
          this.msgInfo.button = [true, false, false],
          this.msgInfo.buttonText = ['OK', '', '']
          this.msgOpen = true
        }
      }

      let comment_ = {
        editor: true,
        depth: depth_,
        parentId: parentIdxNum || 0,
        userId: this.account.id,
        userName: this.account.userName,
        position: this.account.position,
        dept: this.account.department,
      }

      if(!parentIdxNum) {
        this.comments.push(comment_)
      } else {
        const insertAt = this.getSubtreeEndIndex(parentIndexInArray)
        const next_ = [...this.comments]
        next_.splice(insertAt, 0, comment_)
        this.comments = next_
      }
      this.mode = __C.FORM.EDIT_MODE_ADD
    },
    getSubtreeEndIndex(parentIndex) {
      const parentDepth = this.comments[parentIndex].depth
      let i = parentIndex + 1
      while (i < this.comments.length && this.comments[i].depth > parentDepth) i++
      return i
    },
    
    setCommentProps(payload) {
      this.commentPropsLocal = { ...this.commentPropsLocal, ...payload }
    },
    setUpdateComment(flag) {
      this.updatecommentLocal = !!flag
    },
    setCallbackData(payload) {
      this.callbackDataLocal = payload
    },
    getAccountId(_email=null) {
      const email_ = String(_email || this.account.id || '').trim()
      const id = email_.includes('@') ? email_.split('@')[0] : email_
      return id
    },
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Progress Bar & Button Toggle Management
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

    onTogglePlanned() {
      if (this.isPlnOn) {
        this.turnOffPlan()
      } else {
        this.setPlan('planned')
      }
    },
    onToggleHold() {
      if (this.isHldOn) {
        this.turnOffHold()
      } else {
        this.setHold('hold')
      }
    },
    onToggleRequested() {
      if (this.isReqOn) this.turnOffFrom('requested')
      else this.setStage('requested')
    },
    onToggleIssued() {
      if (this.isIssOn) this.turnOffFrom('issued')
      else this.setStage('issued')
    },
    onToggleProgress() {
      if (this.isProOn) this.turnOffFrom('progress')
      else this.setStage('progress')
    },
    onToggleCompleted() {
      if (this.isComOn) this.turnOffFrom('completed')
      else this.setStage('completed')
    },
    onToggleVerified() {
      if (this.isVerOn) this.turnOffFrom('verified')
      else this.setStage('verified')
    },
    onToggleLaunched() {
      if (this.isLunOn) this.turnOffFrom('launched')
      else this.setStage('launched')
    },

    // stage Setting ( !plan/hold )
    // stageOrder: ['requested','issued','progress','completed','verified','launched'],
    setStage(stage) {
      const order = this.stageOrder
      const targetIdx = order.indexOf(stage)
      if (targetIdx < 0) return

      // Plan/Hold Init
      this.clearPlanAndHold()

      for (let i = 0; i <= targetIdx; i++) {
        const st = order[i]
        const m = this.setStageMapping(st)
        const proc = this.ensureProc(m.pc)
        proc[m.st] = st
        proc[m.pr] = st == 'progress' ? 10 : 100
        // if (!proc[m.by]) proc[m.by] = this.account ? this.getAccountId() : ''
        if (!proc[m.dt]) proc[m.dt] = this.today
      }

      for (let i = targetIdx + 1; i < order.length; i++) {
        this.resetStageFields(order[i], { status: '', prog: 0, date: '' })
      }
      if (targetIdx > 2) {
        this.resetStageFields(order[2], { status: 'progress', prog: 100, date: this.today })
      } 
    },

    // stage === 'planned'? 100 : 0
    // modenew ? 100 : 0
    setPlan(stage) {
      
      this.resetAllToZero()     // progress Init
      this.resetStageFields('hold', { status: '', prog: 0, date: '' }) // Hold Init
      if (stage === 'planned') {
        const m = this.setStageMapping('planned')
        const p = this.ensureProc(m.pc)
        p[m.st] = 'planned'
        p[m.pr] = 100
        p[m.dt] = this.today
        // p[m.by] = this.getAccountId()
      } else {
        this.resetStageFields('planned', { status: '', prog: 0, date: '' })
      }
    },

    // hldProg=100 , Others Not Clear
    setHold(stage) {
      // this.resetAllToZero()
      this.resetStageFields('planned', { status: '', prog: 0, date: '' }) // Plan Init
      if (stage === 'hold') {
        const m = this.setStageMapping('hold')
        const p = this.ensureProc(m.pc)
        p[m.st] = 'hold'
        p[m.pr] = 100
        p[m.dt] = this.today
        // p[m.by] = this.getAccountId()
      } else {
        this.resetStageFields('hold', { status: '', prog: 0, date: '' })
      }
    },

    // Button OFF from stage
    turnOffFrom(stage) {
      const order = this.stageOrder
      const start = order.indexOf(stage)
      if (start < 0) return
      for (let i = start; i < order.length; i++) {
        this.resetStageFields(order[i], { prog: 0, date: '' })
      }
      // requested OFF ? plan/hold Prog = 0
      if (start === 0) {        
        this.setPlan('planned')
      }
    },

    // planned/hold OFF
    turnOffPlan() { this.resetStageFields('planned', { prog: 0, date: '' }) },
    turnOffHold() { this.resetStageFields('hold',    { prog: 0, date: '' }) },
    setStageMapping(stage) {
      const map = {
        requested: { pc:'reqProc', st:'reqStatus', pr:'reqProg', by:'reqBy', dt:'reqDate' },
        issued   : { pc:'issProc', st:'issStatus', pr:'issProg', by:'issBy', dt:'issDate' },
        progress : { pc:'proProc', st:'proStatus', pr:'proProg', by:'proBy', dt:'proDate' },
        completed: { pc:'comProc', st:'comStatus', pr:'comProg', by:'comBy', dt:'comDate' },
        verified : { pc:'verProc', st:'verStatus', pr:'verProg', by:'verBy', dt:'verDate' },
        launched : { pc:'lunProc', st:'lunStatus', pr:'lunProg', by:'lunBy', dt:'lunDate' },
        planned  : { pc:'plnProc', st:'plnStatus', pr:'plnProg', by:'plnBy', dt:'plnDate' },
        hold     : { pc:'hldProc', st:'hldStatus', pr:'hldProg', by:'hldBy', dt:'hldDate' },
      }
      return map[stage]
    },
    ensureProc(pc) { return this.item[pc] || (this.item[pc] = {}) },
    resetStageFields(stage, {status = '', prog = 0, date = ''} = {}) {
      const m = this.setStageMapping(stage)
      if (!m) return
      const proc = this.ensureProc(m.pc)
      
      // status !== undefined && !status == '' ? proc[m.st] = status : proc[m.st] = def[m.st]
      proc[m.pr] = prog
      proc[m.dt] = date
    },
    resetAllToZero() {
      // requested~launched 0%
      this.stageOrder.forEach(st => this.resetStageFields(st, { status: '', prog: 0, date: '' }))
    },
    clearPlanAndHold() {
      this.resetStageFields('planned', { status: '', prog: 0, date: '' })
      this.resetStageFields('hold',    { status: '', prog: 0, date: '' })
    },
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Member Name Mapping
    // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    loadMemberNames() {
      // this.adminService.getJGSMembers('SYS_ADMIN,SVC_ADMIN', this.setMembers)
      this.queryLibService.getSqlQueryResult({ 
        idx: 0, 
        name: 'Workorder Members',
        filters: ''
      },this.setMembers).then(res => {
        this.members = Array.isArray(res) ? res.map((item, i) => ({ ...item, no: i + 1 })) : []        
      })
    },
    setMembers(res) {
      this.members = Array.isArray(res) ? res.map((item, i) => ({ ...item, no: i + 1 })) : []
      this.buildMemberMap()
      this.rebuildRequestorOptions()
      this.initReqByIfEmpty()
    },
    buildMemberMap() {
      const map = {};
      (this.members || []).forEach(({ id, userName }) => {
        const local = this.getAccountId(id)
        if (local) map[local] = userName || local
      })
      this.memberNameMap = map
    },
    rebuildRequestorOptions() {
      // Member username Setting
      this.todoReqOptionName = this.QueryReqOption.map(opt => {
        const key = String(opt.value || '')
        return { ...opt, text: this.memberNameMap[key] || opt.text }
      })
    },
    initReqByIfEmpty() {
      const me = this.getAccountId(this.account?.id)
      const exists = this.reqOptionName.some(o => String(o.value) === me)
      if (!this.reqBy && exists) this.reqBy = me
    },
    avatarSrc(idOrEmail) { return getAvatarById(idOrEmail) },
    getManagerName(code) {
      const name_ = this.todoReqOptionName.find(opt => opt.value == code)
      return name_ ? name_.text : ''
    },
  }
}
</script>
